import { render, staticRenderFns } from "./RepairApply.vue?vue&type=template&id=12c7ba20&scoped=true"
import script from "./RepairApply.vue?vue&type=script&lang=js"
export * from "./RepairApply.vue?vue&type=script&lang=js"
import style0 from "./RepairApply.vue?vue&type=style&index=0&id=12c7ba20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c7ba20",
  null
  
)

export default component.exports